import { Input } from 'cd-eft/components/common/Input';
import { observer } from 'mobx-react';
import React, { Fragment, useEffect, useRef } from 'react';
import { FormulaBanner } from '../Common/FormulaBanner';
import {
  ResultsContainer,
  ImageContainer,
  DescriptionContainer,
  InputContainer,
  FormulaPrintModalContainer,
} from '../template/FormulaFormTemplates';
import { StraightDropVM } from './StraightDropVM';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import pdfLogo from 'cd-eft/assets/images/pdf-blue.svg';
import { StageDischargeGraph } from '../Common/StageDischargeGraph';

const StraightDropComponent = (props) => {
  const vm = useRef(new StraightDropVM(props)).current;
  useEffect(() => {
    // on initial render, load form data - desc, img, help link
    vm.getFormData(`${props.section}_${props.title}_${props.id}`);
    //vm.hasResults = true; // REMOVE THIS LINE FOR FULL IMPLEMENTATION
  }, []);
  return (
    <Fragment>
      <FormulaBanner title={vm.formulaTitle} help={vm.bannerHelpLink} />
      <div className="formula-content row ">
        <InputContainer computeCallback={() => { vm.computefnStraightDrop() }} printCallback={() => { vm.launchAndExport() }} isLoading={vm.isLoading} disableCompute={vm.disableComputeBtn} disablePrint={vm.disablePrintBtn} >
          <h2 className='sections-heading'>General</h2>
          <Input
            label="Weir Length (ft)"
            idAndName="weir-length"
            valid={!vm.formValidation.weirLength}
            value={vm.straightDropForm.weirLength}
            className={vm.StraightDropErrorClass('weirLength')}
            type="number"
            step={'0.01'}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
            onChange={(e) => { vm.handleInputChange(e) }}
            onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
          />
          <Input
            label="Head Above Weir (ft)"
            idAndName="head-above-weir"
            valid={!vm.formValidation.headAboveWeir}
            value={vm.straightDropForm.headAboveWeir}
            className={vm?.StraightDropErrorClass('headAboveWeir')}
            type="number"
            step={'0.01'}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
            onChange={(e) => { vm.handleInputChange(e) }}
            onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
          />
          <Input
            label="Weir Elevation (ft)"
            idAndName="weir-elevation"
            valid={!vm.formValidation.weirElevation}
            value={vm.straightDropForm.weirElevation}
            className={vm?.StraightDropErrorClass('weirElevation')}
            type="number"
            step={'0.01'}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
            onChange={(e) => { vm.handleInputChange(e) }}
            onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
          />
          <Input
            label="Sill Elevation (ft)"
            idAndName="sill-elevation"
            valid={!vm.formValidation.sillElevation}
            value={vm.straightDropForm.sillElevation}
            className={vm?.StraightDropErrorClass('sillElevation')}
            type="number"
            step={'0.01'}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
            onChange={(e) => { vm.handleInputChange(e) }}
            onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
          />
        </InputContainer >
        <div className="col formula-information">
          {vm.hasResults ? (
            <Fragment>
              <div className="row formula-results">
                <ResultsContainer>
                  <div className="col result-value-group">
                    <div className="row">
                      <div className="col-auto result-label">Flow Q (cfs):</div>
                      <div className="col-auto result-value">{vm.calculationResults.flowQ !== undefined && vm.calculationResults.flowQ !== null ? vm.roundingHelperString(vm.calculationResults.flowQ as number, 2) : ""}</div>
                    </div>
                  </div>
                </ResultsContainer>
              </div>
              {vm.plotData ? <StageDischargeGraph targetDivId={vm.targetDivID} plotData={vm.plotData} windowOptions={vm.windowOptions} forReport={false} /> : null}
            </Fragment>
          ) : ''}
          <div className="row formula-description">
            {vm.isLoading && <Loader message={''} />}
            <DescriptionContainer>
              <p>{vm.formDescription}
                &nbsp;
                <a target="_blank" href={vm.bannerHelpLink}>
                  Learn More
                  <img src={pdfLogo} alt={'PDF logo'} />
                </a>
              </p>
            </DescriptionContainer>
          </div>
          {vm.image ? <div className="row formula-images">
            <ImageContainer>
              <img
                className="Straight-Drop-image"
                src={vm.image}
                alt={vm.hydraulicFormulaImageDescription}
                title={vm.formulaTitle}
              />
            </ImageContainer>
          </div> : null}

        </div>
        {vm.isLoading && <Loader message={''} />}
      </div>
      <FormulaPrintModalContainer
        vm={vm}
        inputs={vm.exportedInputs}
        results={vm.exportedResults}
        images={[vm.image]}
        formulaName={vm.formulaTitle}
        windowOptions={vm.windowOptionsForPrint}
        stageDischarge={vm.plotData !== undefined ? true : false}// Should be true for this formula. plotData should be propulated in correct format after api results
        stageDischargeData={vm.plotData}
      />
    </Fragment>
  );
};
export const StraightDropFormula = observer(StraightDropComponent);